import { render } from "./product-badges.vue?vue&type=template&id=4f186abd"
import script from "./product-badges.vue?vue&type=script&lang=js"
export * from "./product-badges.vue?vue&type=script&lang=js"

import "./product-badges.vue?vue&type=style&index=0&id=4f186abd&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__